import authAxioInstance from "../../services/authAxioInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

export const companyProfile = createAsyncThunk(
  "profile/fetch",
  async (_, { rejectWithValue }) => {
    let signature = Cookies.get("c_d_token");
    try {
      const response = await authAxioInstance.get(`/EsignServices/getUserDetails`,
        {
          headers: {
            signature: signature
          }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const profileReducer = createSlice({
  name: "profile",
  initialState: {
    profileData: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(companyProfile.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(companyProfile.fulfilled, (state, action) => {

        if (typeof window !== "undefined") {
          sessionStorage.setItem(
            "company_id",
            String(action.payload?.company_id ?? "")
          );
        }
        state.profileData = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(companyProfile.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});

export default profileReducer.reducer;
